import {AuthProvider} from '@/context/Auth/AuthProvider'
import useInternationalization from '@/internationalization/useInternationalization'
import {persistor, store} from '@/store'
import {DEFAULT_INTL} from '@/utils/constants/globalConstants'
import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {IntlProvider} from 'react-intl'
import {Provider} from 'react-redux'
import {PersistGate} from 'redux-persist/integration/react'
import './assets/scss/App.scss'
import './assets/scss/DarkPepsiconnect.scss'

window.__PRODUCTS_APP_BUILD_DATE__ = __BUILD_DATE__

import {useSetCSSVariables} from '@/utils/constants/colors'
import {MarketThemeProvider} from './components/common/theme/MarketThemeProvider'
import {AppRouter} from './routes/AppRouter'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0,
    },
  },
})

function App({shellActive = false, darkTheme = false, path = '', market}) {
  const [language, message] = useInternationalization(DEFAULT_INTL)
  const defaultMarket =
    market === 'IN' ? import.meta.env.VITE_COUNTRY_CODE : market || import.meta.env.VITE_COUNTRY_CODE

  useSetCSSVariables()
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <QueryClientProvider client={queryClient}>
          <IntlProvider locale={language} messages={message}>
            <AuthProvider>
              <MarketThemeProvider market={defaultMarket}>
                <AppRouter shellActive={shellActive} darkTheme={darkTheme} path={path} market={defaultMarket} />
              </MarketThemeProvider>
            </AuthProvider>
          </IntlProvider>
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  )
}

export default App
